import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { appTheme } from '../../../theme';
import {
  DividerWithText,
  FacebookLoginButton,
  FormBox,
  ErrorMessage,
  PageLink,
} from '../../common';
import EmailLoginForm from './EmailLoginForm';

const LoginPage = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  min-height: ${568}px;
  justify-content: center;
`;

const LoginBoxTitle = styled.h1`
  color: ${appTheme.system.title};
  margin: 0;
  text-align: center;
`;

const SocialLogins = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${appTheme.spacing.default};
  padding: ${appTheme.spacing.default};
`;

class LoginFormPage extends React.Component {
  state = {
    error: null,
  };

  handleFacebookResponse = response => {
    this.props
      .onFacebookLogin(response.accessToken)
      .catch(error => this.setState({ error }));
  };

  render() {
    const { onLogin } = this.props;
    const { error } = this.state;

    return (
      <LoginPage>
        <FormBox>
          <LoginBoxTitle>Login</LoginBoxTitle>
          {!!process.env.REACT_APP_FACEBOOK_KEY && (
            <SocialLogins>
              <FacebookLoginButton
                onClick={this.handleFacebookResponse}
                socialId={process.env.REACT_APP_FACEBOOK_KEY}
              />
              {error && <ErrorMessage>{error}</ErrorMessage>}
              <DividerWithText
                backgroundColor={appTheme.system.passive}
                color={appTheme.system.border}
                text="or"
              />
            </SocialLogins>
          )}
          <EmailLoginForm onLogin={onLogin} />
          <PageLink to="/forgot">Forgot password?</PageLink>
          <PageLink to="/signup">
            Need an account? Click here to sign up.
          </PageLink>
        </FormBox>
      </LoginPage>
    );
  }
}

LoginFormPage.propTypes = {
  onFacebookLogin: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
};

export default LoginFormPage;



// WEBPACK FOOTER //
// ./src/modules/LoginFormPage/components/LoginFormPage.js